<template>
    <div class="holoverz-info-banner">
        <div class="holoverz-info-banner__inner">
            <strong>{{ $t('holoverzInfoRow.text') }}</strong>
        </div>
    </div>
</template>

<script>
export default {
    name: "HoloverzInfoRow",
    props: {},
    components: {},
};
</script>

<style lang="scss" scoped>
.holoverz-info-banner {
    width: 100%;
    background-color: #00e6a8;
    color: #000;
    display: flex;
    justify-content: center;
    text-align: center;
    padding: 0.5rem;
}

.holoverz-info-banner__inner {
    max-width: 1400px;
    text-align: center;
    font-size: 10px;
    line-height: 21px;
}
</style>
